import * as React from "react"
import { SVGProps } from "react"

const SvgWarning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    {...props}
  >
    <path d="M137.018-140.001q-10.17 0-18.267-4.972-8.097-4.971-12.595-13.105-4.679-8.077-5.147-17.5-.468-9.423 5.085-18.665l342.43-591.512q5.553-9.242 13.899-13.665 8.346-4.424 17.577-4.424 9.231 0 17.577 4.424 8.346 4.423 13.899 13.665l342.43 591.512q5.553 9.242 5.085 18.665-.468 9.423-5.147 17.5-4.498 8.134-12.595 13.105-8.097 4.972-18.267 4.972H137.018ZM480-247.693q13.731 0 23.019-9.288 9.288-9.288 9.288-23.019 0-13.731-9.288-23.019-9.288-9.288-23.019-9.288-13.731 0-23.019 9.288-9.288 9.288-9.288 23.019 0 13.731 9.288 23.019 9.288 9.288 23.019 9.288Zm.013-104.614q12.756 0 21.371-8.625 8.615-8.625 8.615-21.374v-140.002q0-12.75-8.628-21.374-8.629-8.625-21.384-8.625-12.756 0-21.371 8.625-8.615 8.624-8.615 21.374v140.002q0 12.749 8.628 21.374 8.629 8.625 21.384 8.625Z" />
  </svg>
)

export default SvgWarning;